import { useContext } from "react";
import styles from './Modal.module.scss';
import { ModalContext } from "./Modal";

export interface ModalHeaderProps {
  /**
   * Header content
   */
  children?: React.ReactNode;
  
  /**
   * Optional header title
   */
  title?: string;
  
  /**
   * Whether to show the close button
   * @default true
   */
  showCloseButton?: boolean;
  
  /**
   * Optional custom class for the header
   */
  className?: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ 
  children, 
  title, 
  showCloseButton = true,
  className = ''
}) => {
  const context = useContext(ModalContext);
  
  return (
    <div className={`${styles.modalHeader} ${className}`}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {children}
      {showCloseButton && (
        <button 
          className={styles.closeButton} 
          onClick={context?.onClose}
          aria-label="Close"
          data-testid="modal-close-button"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
    </div>
  );
};
